import React from "react";
import { FaTimes } from "react-icons/fa";
import { v4 as uuid } from "uuid";
import icon3 from "assets/images/icons/clean-cash.png";
import icon4 from "assets/images/icons/hst-final.png";
import icon2 from "assets/images/icons/hustler-clean-cash-token.png";
import icon1 from "assets/images/icons/slot.png";
import Modal from "components/shared/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useError } from 'ErrorProvider';

import {anchorAddBoosterSlotsHustle, refreshAll} from "BlockchainInteractionWax";

const data = [
  {
    id: uuid(),
    icon: icon1,
    cost: "10",
    key: "upgrade_token",
    classes: "w-10 mx-auto mt-2 mb-2",
  },
  {
    id: uuid(),
    icon: icon4,
    cost: "25000",
    key: "hustler_token",
    classes: "w-10 mx-auto mt-2 mb-2",
  },
  {
    id: uuid(),
    icon: icon3,
    cost: "15000",
    key: "clean_cash",
    classes: "w-16",
  },
  {
    id: uuid(),
    icon: icon2,
    cost: "1000",
    key: "dirty_cash",
    classes: "w-16",
  },
];


const AddForm = ({ isOpen, setIsOpen, upgradeSlotsCost, ual }) => {

  const store = useSelector((state) => state);
  const dispatch = useDispatch();
  const { setError } = useError();

  async function handleUpgradeClick() {
    // Call the function you want to execute on click here
    await anchorAddBoosterSlotsHustle(ual, 2, setError)
    await new Promise(resolve => setTimeout(resolve, 3000));
    await refreshAll(dispatch)
    setIsOpen(false)
  }

  if (!upgradeSlotsCost) {
    return null; // or a loading spinner, etc.
}
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      //   className='w-8/12'
    >
      <div
        className="w-full rounded-xlpy-4 px-6 font-Montserrat"
        style={{ backgroundImage: "radial-gradient(#292929, #000000)", border: "6px outset rgba(165, 165, 165, 0.4)" }}
      >
        <>
          <div className="mb-2 flex items-center justify-between">
            <div />
            <div />
            <h2 className="px-5 py-2 text-center font-Montserrat text-2xl font-bold text-white">
              Slot Upgrade Cost
            </h2>
            <FaTimes
              className="block text-2xl text-white hover:cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
          </div>

          <div className="flex justify-center">
            <div>
              {data.map((item) => (
                <div className="flex items-center gap-x-3" key={item.id}>
                  <div className={item.classes}>
                    <img
                      src={item.icon}
                      className="h-full w-full object-contain"
                      alt="Token Icon"
                    />
                  </div>
                  <p className="font-bold text-white">
                    {upgradeSlotsCost[item.key]}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-5 flex justify-center">
          <div className='buttonContainer'>
            <button className="w-32 py-1 px-3" onClick={handleUpgradeClick}>
              Upgrade
            </button>
          </div>
          </div>
        </>
      </div>
    </Modal>
  );
};

export default AddForm;
